/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FlightPointsSourceResult } from './FlightPointsSourceResult';
import {
    FlightPointsSourceResultFromJSON,
    FlightPointsSourceResultFromJSONTyped,
    FlightPointsSourceResultToJSON,
    FlightPointsSourceResultToJSONTyped,
} from './FlightPointsSourceResult';

/**
 * Award pricing collected after a flight search, grouped by loyalty program.
 * @export
 * @interface FlightPointsEnrichmentResponse
 */
export interface FlightPointsEnrichmentResponse {
    /**
     * 
     * @type {string}
     * @memberof FlightPointsEnrichmentResponse
     */
    searchId?: string;
    /**
     * 
     * @type {Array<FlightPointsSourceResult>}
     * @memberof FlightPointsEnrichmentResponse
     */
    sourceResults?: Array<FlightPointsSourceResult>;
}

/**
 * Check if a given object implements the FlightPointsEnrichmentResponse interface.
 */
export function instanceOfFlightPointsEnrichmentResponse(value: object): value is FlightPointsEnrichmentResponse {
    return true;
}

export function FlightPointsEnrichmentResponseFromJSON(json: any): FlightPointsEnrichmentResponse {
    return FlightPointsEnrichmentResponseFromJSONTyped(json, false);
}

export function FlightPointsEnrichmentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightPointsEnrichmentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'searchId': json['search_id'] == null ? undefined : json['search_id'],
        'sourceResults': json['source_results'] == null ? undefined : ((json['source_results'] as Array<any>).map(FlightPointsSourceResultFromJSON)),
    };
}

export function FlightPointsEnrichmentResponseToJSON(json: any): FlightPointsEnrichmentResponse {
    return FlightPointsEnrichmentResponseToJSONTyped(json, false);
}

export function FlightPointsEnrichmentResponseToJSONTyped(value?: FlightPointsEnrichmentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_id': value['searchId'],
        'source_results': value['sourceResults'] == null ? undefined : ((value['sourceResults'] as Array<any>).map(FlightPointsSourceResultToJSON)),
    };
}

